import { UnstyledLink as MatchboxUnStyledLink } from '@sparkpost/matchbox';

/**
 * Matchbox UnstyledLink component.
 * @see https://design.sparkpost.com/components/unstyledlink/
 */
const UnStyledLink = MatchboxUnStyledLink;

export default UnStyledLink;
